import SignupSection from "@/app/components/signupSection/signupSection.component";
import { getClosingBandBackground } from "@/lib/backgrounds";
import type { MarketingLink } from "../marketing.type";

interface FinalCtaProps {
  // The page's own route - decides the band colour (see below).
  path: string;
  title: string;
  text: string;
  cta: MarketingLink;
  // Optional outlined second button (e.g. "Get a Free Demo" beside
  // "Contact Us").
  secondary?: MarketingLink;
}

// Closing call-to-action band for Website 2.0 pages. Reuses the site's
// existing SignupSection (animated arcs, cream "gold" button, outlined
// second button) so every page ends the same way, and always contrasts with
// the footer below: dark above a red footer, red above a dark one.
const FinalCta = ({ path, title, text, cta, secondary }: FinalCtaProps) => {
  const background = getClosingBandBackground(path);
  return (
    <SignupSection
      title={title}
      subtitle={text}
      buttonLabel={cta.label}
      buttonLink={cta.route}
      secondaryButton={
        secondary ? { label: secondary.label, link: secondary.route } : undefined
      }
      background={background}
      // The arcs animation paints its own opaque backdrop, so the dark band
      // needs the dark copy of it (signup_bg_dark.json) - the class alone
      // would be hidden behind the red one.
      animationKey={background === "bg-primary" ? "SIGNUP_BG" : "SIGNUP_BG_DARK"}
    />
  );
};

export default FinalCta;
